"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Session_module_1 = tslib_1.__importDefault(require("./modules/Session.module"));
const Authentication_module_1 = tslib_1.__importDefault(require("./modules/Authentication.module"));
const loadRegistrationCompactModule = () => ({
    hasRouter: true,
    modules: [(0, Session_module_1.default)(), (0, Authentication_module_1.default)()],
});
exports.default = loadRegistrationCompactModule;
